import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const root = document.getElementById('root');
const localeId = root.getAttribute('data-locale');

const Application = () => <App localeId={localeId} />;

if (process.env.NODE_ENV === 'development') {
    ReactDOM.render(<Application />, root);
} else {
    ReactDOM.hydrate(<Application />, root);
}
